/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'errorCircle': {
    width: 16,
    height: 16,
    viewBox: '0 0 23.25 23.09',
    data: '<defs/><path pid="0" class="cls-1" d="M16.62 15.07l-3.54-3.54L16.62 8a1 1 0 0 0-1.41-1.41l-3.54 3.54-3.54-3.55A1 1 0 0 0 6.72 8l3.54 3.54-3.54 3.53a1 1 0 0 0 1.41 1.41l3.54-3.54 3.54 3.54a1 1 0 0 0 1.41-1.41z"/><path pid="1" class="cls-1" d="M11.64 22.5a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/errorCircle.js